module.exports = __webpack_public_path__ + "static/icon_development-37fc44c26dfb4d4e77c617fc8aa2906d.jpg";